// @ts-nocheck 04a9a04b
import _ from 'lodash';
import * as util from '#packages/util';

export default {
  linguistLanguageUrl: `${util.serviceTopology.linguistUrl}/languages`,
  localesUrl: `/linguist/v1/locales`,
  siteTranslatablesProperties: `/_api/site-translator/v2/properties`,
  machineTranslationLimit: '/_serverless/google-limitation//v1/properties',
  apiMethods: _.mapKeys(['POST', 'PUT', 'GET']),
  dataLoadTypes: _.mapKeys([
    'LOAD_LANGUAGES',
    'CHECK_LANGUAGE_STATUS',
    'INITIALIZE_LANGUAGES',
    'ADD_LANGUAGE',
    'UPDATE_LANGUAGE_STATUS',
    'UPDATE_LANGUAGE',
  ]),
};
